import { render, staticRenderFns } from "./TableDataProduct.vue?vue&type=template&id=6de1984e&"
import script from "./TableDataProduct.vue?vue&type=script&lang=js&"
export * from "./TableDataProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports